import React from 'react'
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg bg-transperent">
  <div className="container">
    <a className="navbar-brand" href="#">
      <img src="./images/logo.png" width={120} alt="sls" />
    </a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <Link className="nav-link active" aria-current="page" to="/">Home</Link>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#about">About</a>
        </li>

        <li className="nav-item">
          {/* <a className="nav-link" href="#">Contact US</a> */}
        </li>
        
      </ul>
    </div>
  </div>
</nav>
);
}
export default Navbar;